var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1109_1264)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.25,
    cy: 20,
    r: 20,
    fill: "#7AADED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0733 14.129C24.0733 11.8812 22.2465 10.0524 20.001 10.0524C17.7532 10.0524 15.9244 11.8812 15.9244 14.129C15.9244 16.3743 17.7532 18.2011 20.001 18.2011C22.2465 18.2011 24.0733 16.3743 24.0733 14.129ZM17.4551 14.129C17.4551 12.7252 18.5972 11.583 20.001 11.583C21.4026 11.583 22.5427 12.7252 22.5427 14.129C22.5427 15.5303 21.4026 16.6705 20.001 16.6705C18.5972 16.6704 17.4551 15.5303 17.4551 14.129ZM12.658 24.5308C11.8743 26.4469 12.98 28.55 14.8932 29.1504C18.2608 30.2072 21.6967 30.2198 25.1049 29.1502H25.1051C27.0196 28.549 28.1203 26.4507 27.3465 24.5452C26.1251 21.5389 23.2422 19.5962 20.0018 19.5962C16.7669 19.5962 13.8842 21.5333 12.658 24.5308ZM20.0018 21.1269C22.6163 21.1269 24.9426 22.6949 25.9283 25.1215C26.3606 26.1849 25.7184 27.3535 24.6468 27.6899C21.5625 28.6574 18.4351 28.6575 15.3516 27.6901C14.2638 27.3485 13.642 26.168 14.0747 25.1105C15.0645 22.6906 17.3911 21.1269 20.0018 21.1269Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1109_1264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatar);
export default __webpack_public_path__ + "static/media/profile-avatar.07dec301a2dbe2269204c9920e8960f5.svg";
export { ForwardRef as ReactComponent };